import { render, staticRenderFns } from "./WdfStaffSignature.vue?vue&type=template&id=6ccd6fae"
import script from "./WdfStaffSignature.vue?vue&type=script&lang=js"
export * from "./WdfStaffSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports